/**
 * Load Listeners for expand/collapse.
 */
document.addEventListener('DOMContentLoaded', function(e){
  document.querySelectorAll('.view-more').forEach((item) => {
    item.addEventListener('click', (e) => {
      e.preventDefault()
      const parentContainer = e.currentTarget.parentNode
      parentContainer.classList.toggle("expand")
    })
  })
})
